
import { PropTypes } from 'prop-types';
import { retrunAssets } from "../../utils/getAssets";
import ShowPopUp from "./rentalFacilities/showPopUp";
import PopupDialog from "../news/popupDialog";
import { DecodeHtml } from "../../utils/decodeHtml";

const ProfessionalServices = ({ training }) => {


    const img = training?.thumbnailImage != null ? retrunAssets(training.thumbnailImage[0].url) : ''
    const title = training?.title3
    const description = training?.description3

    const programmes = training?.buttons3?.items?.map((item) => {
        item = item?.content?.properties
        return {
            name: item?.buttonLabel,
            children: item?.Header ? <PopupDialog title={item?.Header} paragraphs={DecodeHtml({ html: item?.description?.markup })} /> : null
        }

    }
    )
    return (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16  place-items-start">
            <div className="w-full max-w-5xl h-[20rem]  2xl:max-w-7xl 2xl:h-[25rem] overflow-hidden  bg-gray-200">
                <img src={img} alt="Professional Services" className="max-w-full w-full h-full object-cover" />
            </div>
            <div className='flex flex-col gap-5'>
                <h1 className="text-4xl font-bold ">{title}</h1>
                <p className="w-auto  text-justify text-sky-900  text-base font-normal leading-normal whitespace-pre-line">{description}</p>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                    {
                        programmes?.map((programme, index) => (
                           
                                <ShowPopUp key={index} title={programme?.name} >
                                    {programme?.children}
                                </ShowPopUp>
                                

                        ))
                    }
                </div>
                
            </div>

        </div>
    )
}
ProfessionalServices.propTypes = {
    training: PropTypes.any
}
export default ProfessionalServices